import React from "react";
import { HomeOutlined } from "@ant-design/icons";
import { HomePhoneProduct } from "../../../../../types/homePhone";

interface DeviceImageProps {
  product?: HomePhoneProduct;
}

const DeviceImage: React.FC<DeviceImageProps> = ({ product }) => (
  <div className="my-devices-card-image">
    {product?.imageUrl ? (
      <img src={product.imageUrl} alt={product.name} />
    ) : (
      <HomeOutlined aria-hidden="true" />
    )}
  </div>
);

export default DeviceImage;
